import { makeStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Link } from '@backstage/core-components';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(10),
    marginBottom: 0,
    borderRadius: 0,
    width: '100%',
    border: 0,
    background: '#212121',
    color: '#FFF',
    '& a:hover': {
      textDecoration: 'none',
    },
  },
  rootMobile: {
    padding: 0,
    border: 'none',
    margin: theme.spacing(2),
    marginTop: theme.spacing(10),
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    '& .v5-MuiTypography-root': {
      marginBottom: theme.spacing(1),
    },
  },
  newsletterSignup: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    '& .v5-MuiTypography-root': {
      marginBottom: theme.spacing(1),
    },
    '& .v5-MuiTextField-root': {
      marginBottom: theme.spacing(1),
      width: '100%',
    },
  },
  svg: {
    width: 64,
    height: 64,
    marginBottom: theme.spacing(2),
  },
}));

const links = {
  docs: [
    {
      title: 'Support Guide',
      href: '/docs/default/component/odp-user-doc/support',
    },
    {
      title: 'Announcements',
      href: 'https://mercedes-benz.ghe.com/orgs/odp/discussions/categories/announcements',
    },
    {
      title: 'User Documentation',
      href: '/docs/default/component/odp-user-doc',
    },
    {
      title: 'Developer Documentation',
      href: '/home/getting-started',
    },
    {
      title: 'Future Developer Journey',
      href: '/home/getting-started',
    },
    {
      title: 'GitHub Org',
      href: 'https://mercedes-benz.ghe.com/odp',
    },
  ],
  governance: [
    {
      title: 'Governance Rules',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/GOVERNANCE.md',
    },
    {
      title: 'Discussions',
      href: 'https://mercedes-benz.ghe.com/orgs/odp/discussions',
    },
    {
      title: 'Project Ownership',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/OWNERS.md',
    },
    {
      title: 'RFCs',
      href: 'https://mercedes-benz.ghe.com/odp/odp/projects/5',
    },
    {
      title: 'ADRs',
      href: 'https://backstage.io/docs/architecture-decisions/',
    },
    {
      title: 'Code Of Conduct',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/CODE_OF_CONDUCT.md',
    },
  ],
  contrib: [
    {
      title: 'Contributing Guide',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/CONTRIBUTING.md',
    },
    {
      title: 'Security Guide',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/SECURITY.md',
    },
    {
      title: 'Coding Style Guide',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/CODING_STYLE.md',
    },
    {
      title: 'Reviewing Guide',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/REVIEWING.md',
    },
    {
      title: 'Versioning Guide',
      href: 'https://mercedes-benz.ghe.com/odp/.github/blob/main/VERSIONING.md',
    },
  ],
};

export const LandingFooter = () => {
  const theme = useTheme();
  const { classes } = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card
      variant="outlined"
      className={isMobile ? classes.rootMobile : classes.root}
    >
      <Grid container item>
        <Grid item sm={12} md={3} className={classes.column}>
          <Typography variant="h6">Documentation</Typography>
          {links.docs.map(link => {
            return (
              <Link to={link.href} key={link.title}>
                <Typography variant="body2" color="white">
                  {link.title}
                </Typography>
              </Link>
            );
          })}
        </Grid>
        <Grid item sm={12} md={3} className={classes.column}>
          <Typography variant="h6">Governance</Typography>
          {links.governance.map(link => {
            return (
              <Link to={link.href} key={link.title}>
                <Typography variant="body2" color="white">
                  {link.title}
                </Typography>
              </Link>
            );
          })}
        </Grid>
        <Grid item sm={12} md={3} className={classes.column}>
          <Typography variant="h6">Contributions</Typography>
          {links.contrib.map(link => {
            return (
              <Link to={link.href} key={link.title}>
                <Typography variant="body2" color="white">
                  {link.title}
                </Typography>
              </Link>
            );
          })}
        </Grid>
      </Grid>
    </Card>
  );
};
